"use client";

import React from "react";
import "./AvatarSkeleton.css";

type AvatarShape = "circle" | "rounded" | "square";
/** Added xl, mega (non-breaking) */
type AvatarSize = "xs" | "sm" | "md" | "lg" | "xl" | "mega";

export interface AvatarSkeletonProps {
  size?: AvatarSize;       // default: md
  shape?: AvatarShape;     // default: circle
  fitParent?: boolean;     // fill parent's width/height
  withBorder?: boolean;    // draw subtle ring while loading
  ringColor?: string;      // ring color if withBorder=true
  showBadge?: boolean;     // show placeholder badge
  badgeSize?: AvatarSize;  // badge sizing; defaults to size
  className?: string;
  ariaLabel?: string;
}

const AvatarSkeleton: React.FC<AvatarSkeletonProps> = ({
  size = "md",
  shape = "circle",
  fitParent = false,
  withBorder = false,
  ringColor,
  showBadge = false,
  badgeSize,
  className = "",
  ariaLabel = "Loading avatar",
}) => {
  // use "fit" class to inherit container size for skeleton
  const sizeClass = fitParent ? "fit" : size;
  const _badgeSize = badgeSize || size;

  return (
    <div
      className={`avatar-skeleton-wrapper ${shape} ${sizeClass} ${className}`}
      role="img"
      aria-label={ariaLabel}
      aria-busy="true"
    >
      <div
        className={`avatar-skeleton ${shape} ${sizeClass} ${withBorder ? "with-border" : ""}`}
        style={{ borderColor: withBorder && ringColor ? ringColor : undefined }}
      />
      {showBadge && <span className={`avatar-skeleton-badge badge-${_badgeSize}`} />}
    </div>
  );
};

export default AvatarSkeleton;
